<div *ngIf="step === 'cadastro'">
  <div class="form-group">
    <a href="javascript:;" (click)="loginFacebook()"
      ><button type="button" class="btn btn-primary btn-lg btn-block">
        <i class="fa fa-facebook"></i> Continuar com Facebook
      </button></a
    >
  </div>

  <div class="form-group">
    <a
      (click)="salvarParametros()"
      href="http://reachr-login-linkedin.herokuapp.com?client_id=77hxwubktxlv3r&client_secret=iuA4Z8fwlaJR9Yue"
      ><button type="button" class="btn btn-info btn-lg btn-block">
        <i class="fa fa-linkedin"></i> Continuar com Linkedln
      </button></a
    >
  </div>

  <div class="form-group">
    <hr data-content="OU" class="hr-text" />
  </div>

  <div class="alert alert-danger" *ngIf="showUsuarioCadastrado" autofocus>
    Erro no cadastro ou usuário já cadastrado.
  </div>
  <div class="alert alert-danger" *ngIf="showLoginSenhaIncorreta" autofocus>
    Login ou senha inválidos!
  </div>
  <div class="alert alert-danger" *ngIf="showCadastroError" autofocus>
    Desculpe, ocorreu um erro ao efetuar o seu cadastro!
  </div>
  <div class="col-12 fonte">
    <div class="form-group">
      <p>Nome*</p>
      <input
        type="text"
        class="form-control"
        placeholder=""
        [(ngModel)]="registerData.nome"
      />
    </div>
    <div class="form-group">
      <p>E-mail*</p>
      <input
        type="email"
        class="form-control"
        placeholder=""
        [disabled]="disableCadastroEmpresa"
        [(ngModel)]="registerData.email"
      />
    </div>
    <div class="form-group">
      <p>Senha*</p>
      <input
        type="password"
        class="form-control"
        placeholder=""
        [(ngModel)]="registerData.password"
      />
    </div>
    <div class="form-group">
      <p>Telefone*</p>
      <input
        type="tel"
        class="form-control"
        placeholder=""
        [(ngModel)]="registerData.telefone"
      />
    </div>
    <div class="form-group" *ngIf="tipoConta === 'empresa'">
      <p>Empresa*</p>
      <input
        type="text"
        class="form-control"
        placeholder=""
        [disabled]="disableCadastroEmpresa"
        [(ngModel)]="registerData.empresa"
      />
    </div>
    <div class="form-group" *ngIf="tipoConta === 'empresa'">
      <p>Cargo*</p>
      <input
        type="text"
        class="form-control"
        placeholder=""
        [(ngModel)]="registerData.cargo"
      />
    </div>
    <div class="form-group">
      <p>
        <input
          class=""
          type="checkbox"
          checked="false"
          [(ngModel)]="registerData.TermosDeUso"
        />&nbsp; Li e aceito os
        <a target="_blank" href="{{ siteUrl }}/termos-de-uso">termos de uso</a>.
      </p>
    </div>
    <div class="form-group text-center">
      <button
        class="btn btn-success btn-block"
        [disabled]="validarJuridico() === false"
        (click)="criarContaEmpresa()"
        *ngIf="tipoConta === 'empresa'"
        name="cta_empresas_criar_conta"
      >
        Criar conta
      </button>
      <button
        class="btn btn-success btn-block"
        [disabled]="validarFisico() === false"
        (click)="criarContaCandidato()"
        *ngIf="tipoConta === 'candidato'"
        name="cta_candidatos_criar_conta"
      >
        Criar conta
      </button>
    </div>
    <p class="cadastrar">
      Já tenho conta!
      <a
        href="{{ siteUrl }}/login"
        routerLink="/login"
        *ngIf="tipoConta === 'empresa' && nextjobtoken === ''"
        ><b>Retornar para o Login.</b></a
      >
      <a
        href="{{ siteUrl }}/login?nextjobtoken={{ nextjobtoken }}"
        *ngIf="tipoConta === 'empresa' && nextjobtoken !== ''"
        ><b>Retornar para o Login.</b></a
      >

      <a
        href="{{ siteUrl }}//paracandidatos/login/vaga/{{ parametros.vagaId }}"
        *ngIf="tipoConta === 'candidato' && nextjobvagaid === ''"
        ><b>Retornar para o Login.</b></a
      >
      <a
        href="{{ siteUrl }}//paracandidatos/login?nextjobvagaid={{
          nextjobvagaid
        }}"
        ><b>Retornar para o Login.</b></a
      >
    </p>
  </div>
</div>

<div
  *ngIf="step === 'cadastroFinalizado'"
  style="min-height: 300px"
  class="d-flex align-items-center justify-content-center"
>
  <div class="row">
    <div class="col-12">
      <h3>Cadastro concluído!</h3>
      <h4>Por favor, confirme seu cadastro no link enviado para seu e-mail.</h4>
    </div>
  </div>
</div>
